import React, { useState } from "react";

interface DoctorRoundsFormProps {
  initialData?: any;
  onSave: (data: any) => void;
  onCancel: () => void;
}

const DoctorRoundsForm: React.FC<DoctorRoundsFormProps> = ({
  initialData,
  onSave,
  onCancel,
}) => {
  const [formData, setFormData] = useState({
    observations: initialData?.observations || "",
    plan: initialData?.plan || "",
    medications: initialData?.medications || [],
  });
  const [newMedication, setNewMedication] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  const addMedication = () => {
    if (newMedication.trim()) {
      setFormData({
        ...formData,
        medications: [...formData.medications, newMedication.trim()],
      });
      setNewMedication("");
    }
  };

  const removeMedication = (index: number) => {
    setFormData({
      ...formData,
      medications: formData.medications.filter((_: string, i: number) => i !== index),
    });
  };

  return (
    <form onSubmit={handleSubmit} className="p-4 space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Observations
        </label>
        <textarea
          value={formData.observations}
          onChange={(e) =>
            setFormData({ ...formData, observations: e.target.value })
          }
          rows={4}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 sm:text-sm"
          placeholder="Enter observations from doctor rounds..."
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">Plan</label>
        <textarea
          value={formData.plan}
          onChange={(e) => setFormData({ ...formData, plan: e.target.value })}
          rows={4}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 sm:text-sm"
          placeholder="Enter treatment plan..."
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Medications
        </label>
        <div className="flex gap-2 mt-1">
          <input
            type="text"
            value={newMedication}
            onChange={(e) => setNewMedication(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                addMedication();
              }
            }}
            className="flex-1 block rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 sm:text-sm"
            placeholder="Enter medication name"
          />
          <button
            type="button"
            onClick={addMedication}
            className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
          >
            Add
          </button>
        </div>
        {formData.medications.length > 0 && (
          <ul className="mt-2 space-y-1">
            {formData.medications.map((med: string, index: number) => (
              <li
                key={index}
                className="flex justify-between items-center p-2 bg-gray-50 rounded"
              >
                <span className="text-sm text-gray-700">{med}</span>
                <button
                  type="button"
                  onClick={() => removeMedication(index)}
                  className="text-sm text-red-600 hover:text-red-900"
                >
                  Remove
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className="flex justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
        >
          Save Doctor Rounds
        </button>
      </div>
    </form>
  );
};

export default DoctorRoundsForm;

